export default "__VITE_ASSET__B$9LA15d__"